import {css, cx} from '@emotion/css';
import React, {useMemo} from 'react';

import {ProgressIndicator} from '@veneer/core';

const Loading = ({height}: {height?: number}): JSX.Element => {
    const className = useMemo(() => {
        return css({height: height ? `${height}px` : '100%'});
    }, [height]);

    return (
        <div className={cx('d-flex align-items-center justify-content-center', className)}>
            <ProgressIndicator />
        </div>
    );
};

export default Loading;
